<template>
    <div class="lottie-container">
        <div ref="lottieEl" class="lottie"></div>
    </div>
</template>

<script>
    export default {
        name: 'animation',
        props: {
            animation: {
                type: Object,
                default: {}
            },
            autoplay: {
                type: Boolean,
                default: true
            },
            play: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                el: undefined
            }
        },
        watch: {
            '$root.mode'() {
                if (this.$refs.lottieEl) {
                    this.$nextTick(() => {
                        this.$root.lottieIESvgResize(this.$refs.lottieEl);
                    })
                }
            },
            play(arg) {
                if ( arg ) {
                    this.el.play();
                }
                else {
                    this.el.pause();
                }
            }
        },
        mounted() {
            let params = {
                container: this.$refs.lottieEl,
                renderer: 'svg',
                loop: true,
                autoplay: this.autoplay,
                animationData: this.animation
            };

            this.el = lottie.loadAnimation(params);
            this.$nextTick(() => this.$root.lottieIESvgResize(this.$refs.lottieEl));
        }
    }
</script>